<template>
  <div class="reportApplication">
    <commonHeader :explain="explain" :title="pageTitle" />
    <!-- 基本信息 -->
    <basicInformation ref="basicInformationRef" v-if="!$route.query.activityCode || editEchoData"
                      :edit-echo-data="editEchoData" use-type="activity"
    />
    <!-- 活动信息 -->
    <activityInformation
      ref="activityInformationRef"
      v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData"
      :set-cache-list="setCacheList"
      :update-form="updateForm"
      :inviter-num="lang === 'zh-CN' && !$store.state.useSimplifiedForm"
      @getIndustryReportActivityCode="(val) => { industryReportActivityCode = val; }"
      @getActivitySource="(val) => { activitySource = val; }"
    />
    <!-- 费用归属 -->
    <!-- !$route.query.activityCode：表示不是编辑页 -->
    <!-- editEchoData：表示是编辑页并且请求数据成功 -->
    <!-- !needOrganizer：表示没有活动组支持 -->
    <!-- addCostEditFlag：表示活动组支持追加的费用可编辑 -->
    <costAscription
      ref="costAscriptionRef"
      v-if="(!$route.query.activityCode || editEchoData) && (!needOrganizer || addCostEditFlag)"
      :edit-echo-data="editEchoData"
      :key="clickIndex"
      cost-ascription-type="activeType"
      :industry-report-activity-code="industryReportActivityCode"
      :activity-source="activitySource"
      @checkAllsmartOrderVOListCommand="handleSuccessAllsmartOrderVOList"
      @checkAllsmartOrderVOListSaveCommand="handleSuccessAllsmartOrderSaveVOList"
    />
    <!-- 拟邀请客户 -->
    <userSelection
      ref="userSelectionRef"
      v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData"
      :cache-list="cacheList"
      :must-write="isMustWrite()"
    />
    <!-- 活动目标 -->
    <activityCatalogue
      ref="activityCatalogueRef"
      v-if="lang === 'zh-CN' && (!$route.query.activityCode || editEchoData)"
      v-show="!$store.state.useSimplifiedForm"
      :edit-echo-data="editEchoData"
      :cache-list="cacheList"
      :update-form="updateForm"
      :set-activity-form="setActivityForm"
    />
    <!-- 活动附件 -->
    <activityFile ref="activityFileRef" v-if="!$route.query.activityCode || editEchoData"
                  :edit-echo-data="editEchoData"
    />

    <!-- 合规资料附件 -->
    <complianceDocuments ref="complianceDocumentsRef" v-if="ifcomplianceComponent" :edit-echo-data="editEchoData" />

    <div class="buttons">
      <el-button plain @click="saveBtn" v-if="saveBtnShow">{{ this.$t('btn.SaveD') }}</el-button>
      <el-button type="primary" @click="submitBtn">{{ this.$t('btn.Submit') }}</el-button>
    </div>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import basicInformation from './component/newApplicationForm/basicInformation';
import activityInformation from './component/newApplicationForm/activityInformation';
import complianceDocuments from './component/newApplicationForm/complianceDocuments.vue';
import userSelection from './component/newApplicationForm/userSelection';
import costAscription from './component/newApplicationForm/costAscription';
import activityFile from './component/newApplicationForm/activityFile';
import activityCatalogue from './component/newApplicationForm/activityCatalogue.vue';
import { newApplicationFormApi, activityRuleApi } from './service';
import { mapState } from 'vuex';
import { hasAllsmartOrder, confirmAllsmartOrderTimeout } from '@/utils/allsmartOrderCheck';
import { confirmPrecheck, confirmBusiness, notifyDetectFailed } from '@/utils/exportComplianceDialog';
import {isNotEmpty, throttle, throttleAsync} from '../../utils/utils';

export default {
  data () {
    return {
      pageTitle: this.$t('home.aff'),
      explain: {
        text: `${this.$t('notic.AppRule')}，`,
        content: this.$t('notic.AppRuleOne')
      },
      editEchoData: null,
      addCostEditFlag: false, // 活动组支持追加的费用是否可编辑
      saveBtnShow: false,
      isSubmitted: false, // 是否已提交：false离开页面会有提示保存信息
      clickIndex: new Date().getTime(),
      lang: localStorage.getItem('lang') || 'zh-CN',
      cacheList: {},
      cform: {},
      timeOut: null,
      industryReportActivityCode: '', // 关联模板活动的活动编码
      activitySource: null, // 活动来源
      ifcomplianceComponent: false // 是否显示合规资料附件
    };
  },
  computed: {
    ...mapState({
      needOrganizer: (state) => state.newApplication.needOrganizer
    })
  },
  components: {
    commonHeader,
    basicInformation,
    activityInformation,
    userSelection,
    costAscription,
    activityFile,
    activityCatalogue,
    complianceDocuments
  },
  methods: {
    /**
     * @description: 是否显示合规资料附件 判断函数
     * @param {*} val 活动信息-是否年度规划线上活动 1-是 0-否
     */
    complianceComponent (val) {
      this.ifcomplianceComponent = val > 0;
    },
    paramsHandler (saveType) {
      // saveType 保存类型 1-草稿  2-提交  3-品推编辑  4-驳回编辑  5-报备提交   6-报备草稿 8-报备申请转活动申请

      let params = {
        // 保存类型
        saveType: saveType
      };
      // 基本信息
      let basicInfoData = this.$refs.basicInformationRef.formData;

      // 活动信息
      let activityInfoData = this.$refs.activityInformationRef.formData;

      // 活动目标
      let activityCatalogueData = this.$refs.activityCatalogueRef?.formData;

      params.marketActivity = {
        // submitType 提交类型(页面类型) quick_submit-快速提交  普通提交-normal_submit  报备提交-report_submit  渠道提交-qd_submit
        submitType: 'normal_submit',
        // 基本信息
        activityCode: basicInfoData.activityCode,
        financialSystemCode: basicInfoData.financialSystemCode,
        financialSystemName: basicInfoData.financialSystemName,
        currencyCode: basicInfoData.currencyCode,
        currencyType: basicInfoData.currencyType,
        currFromRmbRate: basicInfoData.currFromRmbRate,
        applyUserTel: basicInfoData.applyUserTel,
        applyTime: basicInfoData.applyTime,
        salerId: basicInfoData.salerId,
        salerName: basicInfoData.salerName,
        salerDeptCode: basicInfoData.salerDeptCode,
        salerDeptName: basicInfoData.salerDeptName,
        applyUserId: basicInfoData.applyUserId,
        applyUserName: basicInfoData.applyUserName,
        applyUserDeptCode: basicInfoData.applyUserDeptCode,
        applyUserDeptName: basicInfoData.applyUserDeptName,
        applyUserType: basicInfoData.applyUserType,
        // 活动信息
        activityName: activityInfoData.activityName,
        activityGoal: '市场活动类',
        isBatchApprove: activityInfoData.isBatchApprove,
        businessUnit: activityInfoData.businessUnitDisplayed ? activityInfoData.businessUnitDisplayed.join(',') : '',
        activityClassificationCode: activityInfoData.activityClassificationCode,
        activityClassification: activityInfoData.activityClassification,
        relatedActivityCode: activityInfoData.relatedActivityCode,
        relatedActivityName: activityInfoData.relatedActivityName,
        hqActivityCode: activityInfoData.relatedActivityCode,
        hqActivityName: activityInfoData.hqActivityName,
        sourceLink: activityInfoData.sourceLink,
        activityForms: activityInfoData.activityForms,
        organizer: activityInfoData.organizer,
        inviterNum: activityInfoData.inviterNum,
        targetObject: activityInfoData.targetObject,
        targetObjectOther: activityInfoData.targetObjectOther || '',
        activityTypeCode: activityInfoData.activityTypeCode,
        activityType: activityInfoData.activityType,
        qdMeetingSegment: activityInfoData.qdMeetingSegment,
        city: activityInfoData.city,
        expectStartDate: activityInfoData.expectStartDate,
        expectEndDate: activityInfoData.expectEndDate,
        isUnionMarket: activityInfoData.isUnionMarket,
        isInternationalQd: activityInfoData.isInternationalQd,
        unionChannelType: activityInfoData.unionChannelType,
        unionChannelName: activityInfoData.unionChannelName,
        activityLevel: activityInfoData.activityLevel,
        needOrganizer: activityInfoData.needOrganizer,
        budgetAmount: activityInfoData.budgetAmount,
        organizerReason: activityInfoData.organizerReason,
        reportType: this.editEchoData && this.editEchoData.marketActivity && this.editEchoData.marketActivity.reportType, // （1-区域报备 2-行业报备）
        // 邀请单位数：从活动目录数据中获取的单位数(dws)
        invitedUnitNum: activityCatalogueData?.dws,
        // 新业务机会数：从活动目录数据中获取的3个月内可能产生的新业务机会数量(create3m)
        newOpptyNum: activityCatalogueData?.create3m,
        // 推动业务机会数：从活动目录数据中获取的3个月内可能推动的业务机会数量(push3m)
        pushOpptyNum: activityCatalogueData?.push3m,
        // 新业务机会金额
        newOpptyAmount: activityCatalogueData?.create3mAmount || 0,
        // 推动业务机会金额
        pushOpptyAmount: activityCatalogueData?.push3mAmount || 0,
        industryReportActivityCode: this.industryReportActivityCode, // 关联模板活动的活动编码
        isCompliance: activityInfoData.isCompliance // 是否年度规划线上活动 1-是 0-否
      };
      if (isNotEmpty(activityInfoData.mactCommunicationScenarioList)) {
        params.mactCommunicationScenarioList = activityInfoData.mactCommunicationScenarioList;
      }

      // 活动信息-扩展表（后续新增的字段）
      params.marketActivityExpand = {
        activityCode: basicInfoData.activityCode,
        brandPromotionSupportKey: activityInfoData.brandPromotionSupportKey,
        brandPromotionSupport: activityInfoData.brandPromotionSupport,
        remotePoc: activityInfoData.remotePoc,
        unitedDiamondActivity: activityInfoData.unitedDiamondActivity,
        circleActivity: activityInfoData.circleActivity,
        templateVisit: activityInfoData.templateVisit,
        machineDemo: activityInfoData.machineDemo,
        activityBaseName: activityInfoData.activityBaseName,
        activityBaseContactInformation: activityInfoData.activityBaseContactInformation,
        activityBaseUrl: activityInfoData.activityBaseUrl,
        activityBaseDeptCode: activityInfoData.activityBaseDeptCode,
        activityBackgroundPurpose: activityInfoData.activityBackgroundPurpose,
        activityTarget: activityInfoData.activityTarget,
        seniorKeyCustomerActivity: activityInfoData.seniorKeyCustomerActivity
      };
      // 转申请报备缺少参数补充
      if (this.$route.path === '/activityTransferApplication') {
        params.marketActivityExpand.marketingForm = this.editEchoData.marketActivityExpand.marketingForm;
        params.marketActivity.stat = this.editEchoData.marketActivity.stat;
      }
      if (isNotEmpty(activityInfoData.mactAgendaList)) {
        params.mactAgendaList = activityInfoData.mactAgendaList;
      }
      // 活动预计包含板块
      params.mactModuleList = this.$refs.activityInformationRef.plateFilter();

      // 产品线
      params.mactProductLineList = this.$refs.activityInformationRef.productlineSupplementFilter();

      // 拟邀客户
      params.mactJoinCustomerList = this.$refs.userSelectionRef ? this.$refs.userSelectionRef.getTableData() : [];
      if (isNotEmpty(params.mactJoinCustomerList)) {
        params.mactJoinCustomerList.forEach(item => {
          item.phone = item.telephone;
          item.mustFollowCustomer = item.mustFollowC;
          // item.opportunityNameList = item.opportunityName
          // 将业务机会转移到opportunityName字段上"
          // item.opportunityName = item.opportunityName ? item.opportunityName?.join(',') : '';
          if (item.opportunityName && Array.isArray(item.opportunityName)) {
            item.opportunityName = item.opportunityName?.join(',');
          }
        });
      }
      // 费用归属
      // 如果不是活动组支持 || 是活动组支持追加的费用可编辑
      if ((!this.needOrganizer || this.addCostEditFlag) && this.$refs.costAscriptionRef) {
        const getRowTemplateCost = this.$refs.costAscriptionRef.getRowTemplateCost;
        params.mactExpenseBelongVOList = this.$refs.costAscriptionRef.tableData.map(item => {
          item = {
            mactExpenseBelong: {
              ...item,
              activityCode: basicInfoData.activityCode,
              industryReportActivityCode: getRowTemplateCost(item) ? this.industryReportActivityCode : '' // 关联模板活动的活动编码
            },
            activityExpenseDetails: item.activityExpenseDetails,
            advertiseExpenseDetails: item.advertiseExpenseDetails,
            allsmartOrderVOList: item.allsmartOrderVOList
          };
          if (this.$route.path === '/activityTransferApplication') {
            // 转申请则报备申请金额不能修改，则取后台返回的金额
            item.mactExpenseBelong.activityType = 1;
            item.mactExpenseBelong.reportType = this.editEchoData && this.editEchoData.marketActivity && this.editEchoData.marketActivity.reportType; // （1-区域报备 2-行业报备）
          }
          return item;
        });
        // 费用归属总计
        params.marketActivity.totalCost = this.$refs.costAscriptionRef.costTotal;
      } else {
        params.mactExpenseBelongVOList = [];
      }

      // 活动附件
      if (this.$refs.activityFileRef.fileList.length > 0) {
        params.attachFileList = this.$refs.activityFileRef.fileList.map(item => {
          return {
            fileId: item.response ? item.response.data[0].FID : item.fileId,
            fileName: item.name,
            activityCode: basicInfoData.activityCode,
            sourceType: 'Activity'
          };
        });
      }
      // 合规附件
      if (this.$refs.complianceDocumentsRef && this.$refs.complianceDocumentsRef.fileList.length > 0) {
        params.complianceAttachFileList = this.$refs.complianceDocumentsRef.fileList.map(item => {
          return {
            fileId: item.response ? item.response.data[0].FID : item.fileId,
            fileName: item.name,
            activityCode: basicInfoData.activityCode,
            sourceType: 'Compliance'
          };
        });
      }
      return params;
    },
    validateScrollJump (ele, scrollbarData) {
      let eleInfo = ele.$el.getBoundingClientRect();
      if (eleInfo.top < 0) {
        scrollbarData.scrollTop = scrollbarData.scrollTop - (eleInfo.height / 2) - Math.abs(eleInfo.top);
      }
    },
    async subValidate () {
      let mainScrollbar = document.querySelector('.contentScrollbar>.el-scrollbar__wrap');
      // 基本信息校验
      let basicInfoValidate = await this.$refs.basicInformationRef.validateHandler();
      if (!basicInfoValidate) {
        this.validateScrollJump(this.$refs.basicInformationRef, mainScrollbar);
        return;
      }

      // 活动信息校验
      let activityInfoValidate = await this.$refs.activityInformationRef.validateHandler();
      if (!activityInfoValidate) {
        this.validateScrollJump(this.$refs.activityInformationRef, mainScrollbar);
        return;
      }

      // 费用归属校验
      // 如果不是活动组支持 || 是活动组支持追加的费用可编辑
      if (!this.needOrganizer || this.addCostEditFlag) {
        let costValidate = await this.$refs.costAscriptionRef.validateHandler();
        if (!costValidate) return;
      }
      // 活动目标校验
      if (this.lang === 'zh-CN' && (!this.$route.query.activityCode || this.editEchoData) && !this.$store.state.useSimplifiedForm) {
        let activityCatalogueValidate = await this.$refs.activityCatalogueRef.validateHandler();
        if (!activityCatalogueValidate) {
          this.validateScrollJump(this.$refs.activityCatalogueRef, mainScrollbar);
          return;
        }
      }
      // 拟邀请客户校验
      if (this.$refs.userSelectionRef) {
        let userSelectionValidate = await this.$refs.userSelectionRef.validateHandler();
        if (!userSelectionValidate) {
          this.validateScrollJump(this.$refs.userSelectionRef, mainScrollbar);
          return;
        }
      }

      // 活动附件校验
      let fileValidate = await this.$refs.activityFileRef.validateHandler();
      if (!fileValidate) return;

      return true;
    },
    // 校验费用归属广告品费用是否有值无值自动请求接口查询
    async checkAllsmartOrderVOList (type) {
      if (this.$refs.costAscriptionRef) {
        const { dataList } = this.$refs.costAscriptionRef.$refs.costAscriptionTable.tableData;
        dataList.forEach(item => {
          this.$refs.costAscriptionRef.getDetailCommand(item, type);
        });
      } else {
        if (type === 'submit') {
          this.handleSuccessAllsmartOrderVOList();
        } else {
          this.handleSuccessAllsmartOrderSaveVOList();
        }
      }
    },
    isMustWrite () {
      if (!this.$refs.costAscriptionRef?.tableData) return false;
      let isMust = false;
      let isNextList = '000062689;000062692;000062730;000062698;000062699;000062703;000062705;000062706'.split(';');
      // this.$refs.costAscriptionRef.tableData
      for (let refTableRow of this.$refs.costAscriptionRef.tableData) {
        // 如果refTableRow.deptCode>9则取前九位，与isNextList做匹配，如果匹配成功则isMust为true
        if (refTableRow.deptCode > 9) {
          let deptCode = refTableRow.deptCode.toString().substring(0, 9);
          if (isNextList.includes(deptCode)) {
            isMust = true;
          }
        }
      }
      return isMust;
    },
    // 提交事件
    async submitBtn () {
      let validateResult = await this.subValidate();
      if (!validateResult) return;
      const reportType = this?.editEchoData?.marketActivity?.reportType ? this?.editEchoData?.marketActivity?.reportType * 1 : 0;
      const tableData = this.$refs.costAscriptionRef ? this.$refs.costAscriptionRef.tableData : [];
      const isSomeCostZero = tableData.some(item => {
        let groupToatal = Number(item.activityCost) + Number(item.advertisingCost);
        return groupToatal <= 0 && Number(item.reportApplyAmount) > 0;
      });
      // 如果是报备申请转活动申请并且报备类型大于0，则判断费用归属中是否有费用为0的情况
      if (this.$route.path === '/activityTransferApplication' && reportType > 0) {
        if (isSomeCostZero) {
          // this.$confirm(this.$t('notic.costinfo'), this.$t('general.Hint'), {
          //   confirmButtonText: this.$t('btn.OK'),
          //   cancelButtonText: this.$t('btn.Cancel'),
          //   type: 'warning'
          // }).then(() => {
            this.handleAwaitSubmit();
          // }).catch(() => {
          // });
        } else {
          this.handleAwaitSubmit();
        }
      } else {
        this.handleAwaitSubmit();
      }
    },
    // 待提交事件
    async handleAwaitSubmit () {
      if (this.lang === 'zh-CN' && (!this.$route.query.activityCode || this.editEchoData) && !this.$store.state.useSimplifiedForm) {
        let activityCatalogueData = this.$refs.activityCatalogueRef.formData;
        // activityCatalogueData.create3m或者activityCatalogueData.push3m为0则弹窗提示
        activityCatalogueData.create3m = parseInt(activityCatalogueData.create3m);
        activityCatalogueData.push3m = parseInt(activityCatalogueData.push3m);
        if (activityCatalogueData.create3m === 0 || activityCatalogueData.push3m === 0) {
          let dialogBol = false;
          let isNextList = '000062689;000062692;000062730;000062698;000062699;000062703;000062705;000062706'.split(';');
          // this.$refs.costAscriptionRef.tableData
          if (this.$refs.costAscriptionRef) {
            for (let refTableRow of this.$refs.costAscriptionRef.tableData) {
              // 如果refTableRow.deptCode>9则取前九位，与isNextList做匹配，如果匹配成功则dialogBol为true
              if (refTableRow.deptCode > 9) {
                let deptCode = refTableRow.deptCode.toString().substring(0, 9);
                if (isNextList.includes(deptCode)) {
                  dialogBol = true;
                }
              }
            }
            if (dialogBol) {
              let dialogText = [];
              if (activityCatalogueData.create3m === 0) {
                dialogText.push(this.$t('notic.create3m'));
              }
              if (activityCatalogueData.push3m === 0) {
                dialogText.push(this.$t('notic.push3m'));
              }
              this.$confirm(dialogText.join(this.$t('notic.and')) + this.$t('notic.applicationUpload'), this.$t('general.Hint'), {
                confirmButtonText: this.$t('btn.OK'),
                cancelButtonText: this.$t('btn.Cancel'),
                type: 'warning'
              }).then(async () => {
                await this.checkAllsmartOrderVOList('submit');
              }).catch(() => {
              });
            } else {
              await this.checkAllsmartOrderVOList('submit');
            }
          } else {
            await this.checkAllsmartOrderVOList('submit');
          }
        } else {
          await this.checkAllsmartOrderVOList('submit');
        }
      } else {
        await this.checkAllsmartOrderVOList('submit');
      }
    },
    // 提交请求接口
    handleSuccessAllsmartOrderVOList: throttleAsync(async function () {
      // 礼品汇超时规则确认弹窗
      const tableData = this.$refs.costAscriptionRef ? this.$refs.costAscriptionRef.tableData : [];
      const confirmed = await confirmAllsmartOrderTimeout(this, hasAllsmartOrder(tableData));
      if (!confirmed) return;
      // 保存提交类型
      let saveType = 2;
      // 请求接口
      let requestUrl = newApplicationFormApi.activityFormSubimt;

      let { editFlag } = this.$store.state.newApplication;

      // 如果是编辑则调用保存接口
      if (editFlag) {
        requestUrl = newApplicationFormApi.activityFormSave;
      }

      if (editFlag === 2) {
        // 品推编辑 编辑基本信息
        saveType = 3;
      }
      if (editFlag === 3 || editFlag === 1) {
        // 3.驳回编辑 编辑被驳回的费用归属 || 1.编辑全部
        saveType = 4;
      }
      const reportType = this?.editEchoData?.marketActivity.reportType ? this?.editEchoData?.marketActivity.reportType * 1 : 0;
      if (this.$route.path === '/activityTransferApplication' || (reportType > 0)) {
        if (this.$route.query.metaActive !== '/activityQuery') {
          // 处理驳回编辑申请的逻辑
          saveType = 8; // 报备申请转活动申请
        }
        requestUrl = newApplicationFormApi.reportNewSubmit;
      }
      let params = this.paramsHandler(saveType);
      newApplicationFormApi.verificationActivity(params).then(res => {
        confirmPrecheck(this, res, {
          originalBizId: (params.marketActivity && params.marketActivity.activityCode) || ''
        }).then(confirmed => {
          if (confirmed) {
            this.submitRequestCommand(editFlag, params, requestUrl);
          }
        });
      }).catch(() => {
        notifyDetectFailed(this);
      });
    }, 500),
    // 提交请求事件
    submitRequestCommand (editFlag, params, requestUrl) {
      this.$store.commit('setSubPageLoading', true);
      requestUrl(params).then(res => {
        this.$store.commit('setSubPageLoading', false);
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isSubmitted = true;
            this.$message.success(this.$t('general.SubSucc'));
            // 如果是编辑页，就重定向至编辑页
            if (editFlag > 0) {
              this.$router.push({
                path: '/activityDetails',
                query: {
                  activityCode: this.$route.query.activityCode,
                  metaActive: this.$route.query.metaActive ? this.$route.query.metaActive : '/activityQuery'
                }
              });
              return;
            }
            if (this.$route.path === '/activityApplication') {
              // 费用归属提示
              if (this.$refs.costAscriptionRef) {
                let advertiseFlag = this.$refs.costAscriptionRef.tableData.some(item => {
                  return item.advertiseExpenseDetails && item.advertiseExpenseDetails.advertiseOrderDetails.length > 0;
                });
                if (advertiseFlag) {
                  this.$confirm(this.$t('notic.tcuafc'), this.$t('general.Hint'), {
                    confirmButtonText: this.$t('btn.OK'),
                    showCancelButton: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showClose: false,
                    type: 'warning'
                  }).then(() => {
                    if (params.marketActivity.activityClassificationCode === 'AC_01' || params.marketActivity.activityClassificationCode === 'AC_02') {
                      this.getActivityConfirm(params);
                    } else {
                      this.$router.push('/activityQuery');
                    }
                  }).catch(() => {
                  });
                }
              }
              if (params.marketActivity.activityClassificationCode === 'AC_01' || params.marketActivity.activityClassificationCode === 'AC_02') {
                this.getActivityConfirm(params);
              } else {
                this.$router.push('/activityQuery');
              }
            } else {
              this.$router.push('/activityQuery');
            }
          }
        });
      });
    },
    async saveBtn () {
      let fileValidate = this.$refs.activityFileRef.validateHandler();
      if (!fileValidate) return;
      await this.checkAllsmartOrderVOList('save');
    },
    handleSuccessAllsmartOrderSaveVOList () {
      let params = this.paramsHandler(1);
      newApplicationFormApi.activityFormSave(params).then(res => {
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isSubmitted = true;
            this.$message.success(this.$t('general.SaveSucc'));
            this.$router.push('/drafts');
          }
        });
      });
    },
    getEchoData () {
      this.$store.commit('setSubPageLoading', true);
      newApplicationFormApi.getMarketActivityData(this.$route.query.activityCode).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          const result = JSON.parse(JSON.stringify(res.data));
          if (isNotEmpty(result)) {
            if (isNotEmpty(result.mactJoinCustomerList)) {
              result.mactJoinCustomerList.forEach(item => {
                item.telephone = item.phone;
                item.mustFollowC = item.mustFollowCustomer;
              });
            }
            if (isNotEmpty(result.mactExpenseBelongVOList)) {
              result.mactExpenseBelongVOList = result.mactExpenseBelongVOList.filter(item => item.mactExpenseBelong.stat !== 104);
            }
          };
          this.editEchoData = result;
          // 编辑模式：设置简化表单状态
          if (isNotEmpty(result.marketActivity)) {
            // 品推编辑（editFlag=2）时，按活动原 formType 显示
            const isPintuiEdit = this.$store.state.newApplication.editFlag === 2;
            if (isPintuiEdit) {
              this.$store.commit('setUseSimplifiedForm', result.marketActivity.formType === 'simplified');
            } else {
              // 简化UI用户编辑自己的申请时，始终使用简化表单（兼容历史 formType='normal' 的数据）
              this.$store.commit('setUseSimplifiedForm', this.$store.state.useSimplifiedUI || result.marketActivity.formType === 'simplified');
            }
          }
          if (isNotEmpty(result.marketActivity)) {
            this.industryReportActivityCode = result.marketActivity.industryReportActivityCode;
          }
          this.clickIndex = new Date().getTime();
          this.$store.commit('newApplication/setIsUnionMarket', '0');
          // 是否需要活动组支持
          this.$store.commit('newApplication/setNeedOrganizer', result.marketActivity.needOrganizer);
          if (result.marketActivity.needOrganizer) {
            // 活动组支持追加的费用是否可编辑
            // 000 为总部报备活动
            this.addCostEditFlag = result.mactExpenseBelongVOList.some(item => {
              return item.allowEdit && item.mactExpenseBelong.deptCode !== '000';
            });
          }
        }
      });
    },
    getActivityConfirm (params) {
      this.$confirm(this.$t('notic.ActivityNotice'), '提示', {
        confirmButtonText: this.$t('btn.Yes'),
        cancelButtonText: this.$t('btn.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        if (params.marketActivity.sourceLink) {
          window.open(params.marketActivity.sourceLink, '_blank');
          this.$router.push('/activityQuery');
        } else {
          window.open('https://km.ruijie.com.cn/kms/knowledge/index.jsp?j_module=true&catefdId=17be332595eff54e3d2db924e7bbbdc0#j_path=%2FdocCategory%3FclickMenu%3D1&docCategory=17f74271c1c2c745a89dd744bccafd71', '_blank');
          this.$router.push('/activityQuery');
        }
      }).catch(() => {
        this.$router.push('/activityQuery');
      });
    },
    setCacheList (key, value) {
      this.$set(this.cacheList, key, value);
    },
    updateForm (form) {
      this.cform = { ...this.cform, ...form };
    },
    /**
     * @description: 将拟邀请总人数提交到活动信息模块中与之前逻辑统一
     * @param {*} key 需要修改的activityInformation中的formData中的key
     * @param {*} value 需要修改为的对应值
     */
    setActivityForm (key, value) {
      this.$refs.activityInformationRef.updateValue(key, value);
    }
  },
  mounted () {
    // 新建模式：useSimplifiedForm 继承用户身份
    this.$store.commit('setUseSimplifiedForm', this.$store.state.useSimplifiedUI);
    // 保存按钮显示隐藏：如果是申请页面 || 从草稿页来的
    this.saveBtnShow = this.$route.path === '/activityApplication' || this.$route.query.activeName === 'drafts';
    if (this.$route.query.activityCode) {
      this.pageTitle = this.$t('general.EventsEditor');
      this.isSubmitted = true;
      this.getEchoData();
      if (sessionStorage.getItem('applicationEditFlag')) {
        this.$store.commit('newApplication/setEditFlag', Number(sessionStorage.getItem('applicationEditFlag')));
      }
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('applicationEditFlag', this.$store.state.newApplication.editFlag);
      });
    }
  },
  beforeDestroy () {
    // 离开表单页面时重置简化表单状态，防止状态残留
    this.$store.commit('setUseSimplifiedForm', false);
  },
  beforeRouteLeave (to, from, next) {
    // 如果没有提交并且填写了活动名称，则提示该信息
    if (!this.isSubmitted && this.$refs.activityInformationRef.formData.activityName) {
      this.$confirm(this.$t('general.OKSad'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        this.saveBtn().then(() => {
          next();
        });
      }).catch(() => {
        next();
      });
    } else {
      sessionStorage.removeItem('applicationEditFlag');
      this.$store.commit('newApplication/setEditFlag', 0);
      next();
    }
  },

  watch: {
    cform: {
      handler (newVal, oldVal) {
        if (this.lang !== 'zh-CN') return;
        if (this.timeOut) {
          clearTimeout(this.timeOut);
        }
        this.timeOut = setTimeout(() => {
          const form = {
            activityClassify: newVal.activityClassification, // 活动分类
            activityForm: newVal.activityForms, // 活动形式
            sponsor: newVal.organizer, // 主办方
            invitePeopleNum: newVal.inviterNum, // 拟邀请人数
            mainTarget: newVal.targetObject, // 主要目标对象
            activityType: newVal.activityType, // 活动类型
            inviteUnitsNum: newVal.dws, // 拟邀请单位数
            threeMonthsNewOpp: newVal.create3m, // 三个月内预计新建业务机会
            threeMonthsPromoteOpp: newVal.push3m // 预计三个月内推动业务机会数
          };
          activityRuleApi.matchRule(form).then(res => {
            const val = res.data === null ? 'B' : res.data;
            this.$refs.activityInformationRef.updateValue('activityLevel', val);
          });
        }, 1000);
      },
      deep: true
    }

  }
};
</script>

<style scoped>
.reportApplication .buttons {
  text-align: center;
}
</style>
